export default "__VITE_ASSET__CgQ6DQ7___"